var React = require('react');

function Stand (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 40h1680V30S1340 0 840 0 0 30 0 30z","fill":"#fff"}));
}

Stand.defaultProps = {"fill":"none","preserveAspectRatio":"none","viewBox":"0 0 1680 40","className":"position-absolute width-full z-1","style":{"bottom":"-1px"}};

module.exports = Stand;

Stand.default = Stand;
